import { registerAnalyticsProviders } from '@/services/analytics';
import { FathomAnalytics } from './providers/fathom';
import { Ga4Analytics } from './providers/ga4';
import { GoogleTagManagerAnalytics } from './providers/googleTagManager';
import { MetaPixelAnalytics } from './providers/metaPixel';
import { OpenAiAdsAnalytics } from './providers/openAiAds';

export function setupAnalytics(): void {
  registerAnalyticsProviders([
    new Ga4Analytics(),
    new FathomAnalytics(),
    new MetaPixelAnalytics(),
    new OpenAiAdsAnalytics(),
    new GoogleTagManagerAnalytics(),
  ]);
}
